import { ButtonLink, Card, ConseqraLogo, Eyebrow, Lifecycle } from '../components/SiteShell'
import { InteractiveDecisionGraph } from '../components/InteractiveDecisionGraph'
import { ProductWorkflowMockup } from '../components/ProductWorkflowMockup'

export function HomePage() {
  return <>
    <style>{`
      .hero--product {
        display:grid;
        grid-template-columns:minmax(0,1fr);
        justify-items:center;
        align-items:start;
        width:100%;
        margin-left:auto;
        margin-right:auto;
        min-height:auto;
        padding-top:46px;
        margin-bottom:62px;
      }
      .hero--product .hero__copy {
        width:min(100%,1100px);
        text-align:center;
        margin:0 auto 28px;
      }
      .hero--product .hero__copy::before {
        left:50%;top:10px;width:620px;height:280px;transform:translateX(-50%);
        background:rgba(22,139,255,.075);filter:blur(120px);
      }
      .hero--product h1 {max-width:1100px;margin:22px auto 24px;font-size:clamp(54px,5.2vw,74px);line-height:1.08;letter-spacing:-.035em}
      .hero--product .lede {max-width:900px;margin:0 auto;font-size:20px;line-height:1.62}
      .architecture-explainer{margin-top:0}
      .architecture-explainer__intro{margin-bottom:26px;display:flex;justify-content:space-between;align-items:end;gap:30px}
      .architecture-explainer__intro>div{max-width:760px}.architecture-explainer__intro p{color:var(--axiom-text-secondary-dark);line-height:1.55}
      .architecture-explainer .interactive-graph{width:100%}
      .hero--product>.product-workflow{width:100%;justify-self:stretch;align-self:start;margin:0}
      .hero--product,.lifecycle-section,.architecture-explainer,.platform-section{margin-bottom:64px}
      @media(max-width:900px){.hero--product{justify-items:center;align-items:start;padding-top:30px}.hero--product .hero__copy{align-items:center;text-align:center;margin-left:auto;margin-right:auto}.hero--product h1,.hero--product .lede{margin-left:auto;margin-right:auto}.hero--product>.product-workflow{justify-self:stretch}.architecture-explainer__intro{display:block}}
    `}</style>

    <section className="hero hero--product">
      <div className="hero__copy">
        <div className="product-brand"><ConseqraLogo /></div>
        <h1>The decision control plane for consequential action.</h1>
        <p className="lede">See consequential decisions move through context, evidence, policy, authority, approval and action — in one governed operational workflow.</p>
      </div>
      <ProductWorkflowMockup />
    </section>

    <section className="lifecycle-section lifecycle-section--interactive section-band section-band--lifecycle"><Eyebrow>The governed path</Eyebrow><h2>From intent to verified outcome.</h2><p className="muted">Explore each stage to see how Conseqra keeps a consequential decision controlled from objective through outcome.</p><Lifecycle detailed /></section>

    <section className="architecture-explainer">
      <div className="architecture-explainer__intro"><div><Eyebrow>Under the hood</Eyebrow><h2>The governed decision model.</h2><p>Conseqra separates intelligence from authority. Proposals are evaluated against evidence, policy and delegated authority before an Action Binding can become executable.</p></div><ButtonLink to="/platform">Explore platform capabilities</ButtonLink></div>
      <InteractiveDecisionGraph mode="product" />
    </section>

    <section className="platform-section">
      <Eyebrow>Platform</Eyebrow><h2>Control the whole decision lifecycle.</h2>
      <div className="grid grid--3"><Card title="Decision Intelligence">Context, evidence and mechanisms produce governed proposals.</Card><Card title="Governance & Authority" proof>Policy, delegation and approval are independently enforceable.</Card><Card title="Decision Observability">Reconstruct what happened, why and with which evidence.</Card></div>
    </section>

    <section className="closing"><div><h2>Build accountability into autonomous decision-making.</h2><p className="muted">Conseqra is being built by Semantic Secured as infrastructure for organisations that need consequential decisions to be controllable, attributable and reconstructable.</p></div></section>
  </>
}
